<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 sm8 text-xs-center ma-3 pa-3>
        <v-layout justify-center wrap row>
          <v-flex xs10 headline>
            Enter your code
          </v-flex>
          <v-flex xs8 pa-3 mt-3 style="max-width:550px">
            <v-alert
              :value="error"
              type="error"
              outline
            >
              {{ error }}
            </v-alert>
            <v-text-field
              outline
              label="Code"
              v-model="code"
              class="codeInput"
              @keyup.enter="submitCode"
              color="secondary"
            >
            </v-text-field>
            <v-btn
              color="secondary"
              large
              @click="submitCode"
              v-if="!loading"
            >
              Submit
            </v-btn>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secondary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import RedeemService from '@/services/RedeemService'

export default {
  components: {
  },
  data: function () {
    return {
      loading: null,
      code: null,
      school: null,
      error: null
    }
  },
  mounted: async function () {
    if (this.$route.query.code) {
      const inviteCode = this.$route.query.code;
      this.code = inviteCode;
      this.loading = true

      try {
        const result = await RedeemService.get(this.code)

        if (result.data.type === 'join') {
          if (this.$store.getters.loggedIn) {
            this.$router.push({
              path: '/in/code/join/' + result.data.code
            })
          } else {
            this.$router.push({
              path: '/in/code/signup/' + result.data.code
            })
          }
        } else if (result.data.type === 'source') {
            this.$router.push({
              path: '/in/code/source/' + result.data.code
            })
        } else if (result.data.type === 'redemption') {
            this.$router.push({
              path: '/in/code/redemption/' + result.data.code
            })
        } else {
          this.error = 'Unable to recognize code.'
        }
      } catch (err) {
        this.error = err.response.data.error;
      }
      this.loading = false
    }
  },
  methods: {
    async submitCode () {
      if (this.code === null) {
        this.error = 'You must enter a code.'; 
      }
      this.loading = true
      try {
        const result = await RedeemService.get(this.code)

        if (result.data.type === 'join') {
          if (this.$store.getters.loggedIn) {
            this.$router.push({
              path: '/in/code/join/' + result.data.code
            })
          } else {
            this.$router.push({
              path: '/in/code/signup/' + result.data.code
            })
          }
        } else if (result.data.type === 'source') {
            this.$router.push({
              path: '/in/code/source/' + result.data.code
            })
        } else if (result.data.type === 'redemption') {
            this.$router.push({
              path: '/in/code/redemption/' + result.data.code
            })
        } else {
          this.error = 'Unable to recognize code.'
        }
      } catch (err) {
        this.error = err.response.data.error;
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>

.codeInput >>> input {
  text-transform: uppercase;
}

</style>
